/**
 * Application methods
 */
import bootstrap from "./bootstrap";
import register from "./register";

/**
 * Plugin server methods
 */
import services from "./services";

export default {
  register,
  bootstrap,
  services,
};
